import { Capacitor } from '@capacitor/core';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale/pt-BR';
import { useEffect, useState } from 'react';
import { ParticipantsPicks } from '../../app/private/TournamentById/Participants/participantsPicks';
import { CurrencyFormatter } from '../../helpers/utils';
import {
	experiencieBagdetName,
	experiencieBagdetTableView,
} from '../../types/experiencieBagdet';
import { FeedPickProps } from '../../types/pickFeed';
import ModalTolltipPicks from '../Modal/Tooltip/ModalPicks';
import TabsInLinePick from '../TabsInLinePick';

interface Props {
	icon: string | JSX.Element;
	disabled?: boolean;
	tournamentGroup?: FeedPickProps | null;
	proposal?: any[];
}

export default function TooltipPick({
	icon,
	disabled = false,
	tournamentGroup,
	proposal = [],
}: Props) {
	const [isOpen, setIsOpen] = useState(false);
	const [selectedTournament, setSelectedTournament] = useState<any | null>(
		null
	);

	const handleClick = () => {
		setIsOpen(!isOpen);
	};

	useEffect(() => {
		const handleClickOutside = () => setIsOpen(false);

		document.addEventListener('click', handleClickOutside);
		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, []);

	return (
		<>
			<button
				onClick={(e: any) => {
					e.stopPropagation();
					if (disabled) return;
					handleClick();
				}}
			>
				{icon}
			</button>

			<ModalTolltipPicks
				id={'modalTooltip'}
				open={isOpen}
				onClose={handleClick}
			>
				{tournamentGroup && (
					<TabsInLinePick
						initialPage="Torneios"
						render={[
							{
								title: 'Torneios',
								renderPage: () => (
									<table className="w-full table-auto">
										<thead className="h-6">
											<tr>
												<th className="text-left self-stretch w-8 text-[#7A7A7A] text-sm font-medium font-bahnschrift leading-3 tracking-tight">
													Torneio
												</th>
												<th className="text-center self-stretch w-16 text-[#7A7A7A] text-sm font-medium font-bahnschrift leading-3 tracking-tight">
													Inscrição
												</th>
												<th className="text-center self-stretch text-[#7A7A7A] text-sm font-medium font-bahnschrift leading-3 tracking-tight">
													Re-Entradas
												</th>
												<th className="text-center self-stretch text-[#7A7A7A] text-sm font-medium font-bahnschrift leading-3 tracking-tight">
													Prêmio Máx.
												</th>
												<th className="text-center self-stretch w-16 text-[#7A7A7A] text-sm font-medium font-bahnschrift leading-3 tracking-tight">
													Entradas
												</th>
											</tr>
										</thead>
										<tbody>
											{proposal.map(
												(item: any, index: number) => (
													<tr
														key={index}
														onClick={(e) => {
															e.stopPropagation();
															setSelectedTournament(
																item
															);
														}}
														className="cursor-pointer h-6 even:bg-neutral-800/10"
													>
														<td className="text-left underline text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
															{
																item.tournamentPickId.split(
																	'-'
																)[0]
															}
														</td>

														<td className="text-center text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
															R${' '}
															{CurrencyFormatter(
																Number(
																	item.entryFee
																)
															)}
														</td>
														<td className="text-center text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
															{
																item
																	.tournamentPickData
																	.reentryMaxQtd
															}
														</td>
														<td className="text-center text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
															R${' '}
															{CurrencyFormatter(
																Number(
																	item
																		.tournamentPickData
																		.prizeAmt
																) +
																	Number(
																		item
																			.tournamentPickData
																			.prizeAmtBonus
																	)
															)}
														</td>
														<td className="text-center text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
															{
																item
																	.tournamentPickData
																	.allEntries
															}
															/
															{
																item
																	.tournamentPickData
																	.entryMaxQtd
															}
														</td>
													</tr>
												)
											)}
										</tbody>
									</table>
								),
							},
							{
								title: 'Regras',
								renderPage: () => (
									<div className="px-3">
										<div
											className="w-full overflow-y-auto"
											dangerouslySetInnerHTML={{
												__html:
													Capacitor.getPlatform() ===
													'ios'
														? tournamentGroup?.rules
																.contentIOS
														: Capacitor.getPlatform() ===
														  'android'
														? tournamentGroup?.rules
																.contentAndroid
														: tournamentGroup?.rules
																.content,
											}}
										/>
									</div>
								),
							},
						]}
					/>
				)}
			</ModalTolltipPicks>

			{selectedTournament && (
				<ModalTolltipPicks
					id="modalTournamentDetails"
					open={!!selectedTournament}
					onClose={() => setSelectedTournament(null)}
				>
					{tournamentGroup && (
						<TabsInLinePick
							initialPage="Geral"
							render={[
								{
									title: 'Geral',
									renderPage: () => (
										<div className="flex flex-col gap-2">
											<div className="flex flex-row justify-between gap-3 w-full">
												<div className="text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
													ID do Torneio
												</div>
												<div className="text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
													{
														selectedTournament.tournamentPickId
													}
												</div>
											</div>
											<div className="flex flex-row justify-between gap-3 w-full">
												<div className="text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
													Vl. Inscrição
												</div>
												<div className="text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
													R${' '}
													{CurrencyFormatter(
														Number(
															selectedTournament.entryFee
														)
													)}
												</div>
											</div>
											<div className="flex flex-row justify-between gap-3 w-full">
												<div className="text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
													Prêmio Máximo
												</div>
												<div className="text-xs font-light font-bahnschrift leading-tight text-success">
													R${' '}
													{CurrencyFormatter(
														Number(
															selectedTournament
																.tournamentPickData
																.prizeAmt
														) +
															Number(
																selectedTournament
																	.tournamentPickData
																	.prizeAmtBonus
															)
													)}
												</div>
											</div>
											<div className="flex flex-row justify-between gap-3 w-full">
												<div className="text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
													Total/Máximo de Inscrições
												</div>
												<div className="text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
													{
														selectedTournament
															.tournamentPickData
															.allEntries
													}
													/
													{
														selectedTournament
															.tournamentPickData
															.entryMaxQtd
													}
												</div>
											</div>
											<div className="flex flex-row justify-between gap-3 w-full">
												<div className="text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
													Minhas Inscrições
												</div>
												<div className="text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
													{
														selectedTournament
															.tournamentPickData
															.myEntries
													}
												</div>
											</div>
											<div className="flex flex-row justify-between gap-3 w-full">
												<div className="text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
													Quantidade de Pick
												</div>
												<div className="text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
													{
														selectedTournament
															.tournamentPickData
															.tier
													}
												</div>
											</div>
											<div className="flex flex-row justify-between gap-3 w-full">
												<div className="text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
													Experiência
												</div>
												<div className="text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
													<div className="w-40 flex gap-2">
														{selectedTournament.tournamentPickData.experiencie.map(
															(e: any) => (
																<div
																	key={e}
																	className="w-40 inline-flex justify-end"
																>
																	{experiencieBagdetName(
																		e
																	)}
																	{experiencieBagdetTableView(
																		e
																	)}
																</div>
															)
														)}
													</div>
												</div>
											</div>
											<div className="flex flex-row justify-between gap-3 w-full"></div>
											<div className="flex flex-row justify-between gap-3 w-full">
												<div className="text-black text-xs font-light font-bahnschrift leading-tight">
													Eventos
												</div>
											</div>
											{tournamentGroup.events.map(
												(item: any, index: number) => (
													<div
														key={index}
														className="flex flex-row justify-between gap-3 w-full"
													>
														<div className="text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
															{item.home.name} x{' '}
															{item.away.name}
														</div>
														<div className="text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
															{format(
																item.startAt.replace(
																	'Z',
																	''
																),
																"dd/MM • EEE • HH'h'mm",
																{ locale: ptBR }
															)}
														</div>
													</div>
												)
											)}
										</div>
									),
								},
								{
									title: 'Participantes',
									renderPage: () => (
										<div className="px-3">
											<ParticipantsPicks
												tournamentStatus={
													selectedTournament
														.tournamentPickData
														.status
												}
												tournamentPickId={
													selectedTournament.tournamentPickId
												}
											/>
										</div>
									),
								},
								{
									title: 'Premiação',
									renderPage: () => (
										<div className="">
											{selectedTournament.award.pickTrackRegistrations
												.filter(
													(selectedpick: any) =>
														Number(
															selectedpick.qtdSelectPick
														) ===
														Number(
															selectedTournament
																.tournamentPickData
																.tier
														)
												)
												.map((track: any) => {
													return track.awards.map(
														(
															registrations: any,
															index: number
														) => (
															<div
																key={index}
																className="flex justify-between items-center gap-2 px-1 pb-1"
															>
																<div className="text-center self-stretch text-neutral-400 text-xs font-bahnschrift leading-[10px]">
																	{
																		registrations.placingInitial
																	}
																	/
																	{
																		registrations.placingFinal
																	}{' '}
																	Picks
																	Correto
																</div>
																<div className="flex flex-col gap-0.5 text-center self-stretch text-black text-[14px] font-medium font-bahnschrift leading-[10px]">
																	{registrations.creditType ===
																	'Real'
																		? `R$ ${CurrencyFormatter(
																				(parseFloat(
																					registrations.percentAward
																				) /
																					100) *
																					Number(
																						selectedTournament
																							.tournamentPickData
																							.prizeAmt
																					)
																		  )}`
																		: registrations?.creditType ===
																		  'Bônus'
																		? `B$ ${CurrencyFormatter(
																				Number(
																					registrations
																						.placingInitial
																						?.fixedValueAward
																				)
																		  )}`
																		: ''}
																	<span className="text-[9px] font-medium text-[#73777c] font-bahnschrift">
																		{registrations?.creditType ===
																		'Real'
																			? `(${registrations.percentAward.replace(
																					'.',
																					','
																			  )}%)`
																			: registrations?.creditType ===
																			  'Bônus'
																			? '(Bônus)'
																			: ''}
																	</span>
																</div>
															</div>
														)
													);
												})}
										</div>
									),
								},
							]}
						/>
					)}
				</ModalTolltipPicks>
			)}
		</>
	);
}
